// extracted by mini-css-extract-plugin
module.exports = {"reportButton":"_reportPostButton_reportButton__80q7Q","reportButtonReported":"_reportPostButton_reportButtonReported__HVw1U"};